import FooterSection from "./footerSection/footerSection.component";
import HeaderSection from "./headerSection/headerSection.component";
import FAQSection from "./faqSection/faqSection.component";
import QuestionsAccordian from "./questionsAccordion/questionsAccordion.component";
import MerchantsSection from "./merchantSection/merchantsSection.component";
import CustomerTestimonialSection from "./customerTestimonialSection/customerTestimonialSection.component";
import StepsSection from "./stepsSection/stepsSection.component";
import DownloadSection from "./downloadSection/downloadSection.component";
import InfiniteScroll from "./infiniteScroll/infiniteScroll.component";
import LottieAnimation from "./lottieAnimation/lottieAnimation.component";
import { PaginationDots } from "./paginationDots/paginationDots.component";
import LayoutShell from "./layoutShell/layoutShell.component";
import CommonImage from "./commonImage/commonImage.component";
import ContactUsForm from "./contactUsForm/contactUsForm.component";
import WhatsAppFab from "./whatsAppFab/whatsAppFab.component";
import HeroBtnGroup from "./heroBtnGroup/heroBtnGroup.component";
import JsonLd from "./jsonLd/jsonLd.component";
import RelatedPagesSection from "./relatedPagesSection/relatedPagesSection.component";
import RelatedBlogPostsSection from "./relatedBlogPostsSection/relatedBlogPostsSection.component";
import RichText, { plainText } from "./richText/richText.component";

// FormikInput, FormikRadio, and LoginModal are deliberately NOT re-exported
// here. They pull in `formik` (+ its `lodash-es` tree) and, via LoginModal ->
// "@/utils", the shared axios instance ("crypto-js"). This barrel is imported
// by ~50 files across nearly every page for lightweight, universal pieces
// (CommonImage, FAQSection, etc.) - re-exporting the form/login code here
// dragged that weight into every page's bundle even where no form/login UI
// exists. The handful of real consumers (checkoutPage.component.tsx,
// signupForm.component.tsx and its addressSelector) import these three
// directly from their own files instead: "./formikInput/formikInput.component",
// "./formikRadio/formikRadio.component", "./loginModal/loginModal.component".
export {
  JsonLd,
  FooterSection,
  HeaderSection,
  FAQSection,
  QuestionsAccordian,
  MerchantsSection,
  CustomerTestimonialSection,
  StepsSection,
  DownloadSection,
  InfiniteScroll,
  LottieAnimation,
  PaginationDots,
  LayoutShell,
  CommonImage,
  ContactUsForm,
  WhatsAppFab,
  HeroBtnGroup,
  RelatedPagesSection,
  RelatedBlogPostsSection,
  RichText,
  plainText,
};
